module.exports = __webpack_public_path__ + "static/img/465_phase_function_Paper_PointsHejduk_Prediction.27feeb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/465_phase_function_Paper_PointsHejduk_Prediction.png
// module id = lpAw
// module chunks = 0